// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__3bdYS","clinicsSelect":"TableHeading_clinicsSelect__MAWLu"};